import {
  BACKGROUND_WRITE_KEY,
  CORNER_WRITE_KEY,
  WriteIndicator,
} from '../../../shared/write/writeIndicatorKeys/writeIndicatorKeys';
import { useIsMutating } from '@tanstack/react-query';

/**
 * What `GlobalMutatingBackdrop` shows for the writes in flight. A backdrop
 * write wins over a corner one, since it is the one that must block taps.
 *
 * Background writes (`useWrite`'s `indicator: 'none'`) show nothing: they are
 * fire-and-forget tracking, and the authed layout's mount page view blocked
 * every first paint behind a cold server action. The keyed counts are
 * subtracted, not filtered, so every count uses react-query's key matching.
 */
export function useWriteIndicator(): WriteIndicator {
  const writingCount = useIsMutating();
  const backgroundCount = useIsMutating({ mutationKey: BACKGROUND_WRITE_KEY });
  const cornerCount = useIsMutating({ mutationKey: CORNER_WRITE_KEY });
  if (writingCount > backgroundCount + cornerCount) return 'backdrop';
  if (cornerCount > 0) return 'corner';
  return 'none';
}
